<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper" [ngClass]="{'dark-theme': showDarktheme, 'bg-white': !showDarktheme}">

    <ng-template #updateAvailable let-modal>
        <div class="p-20">
            <div class="container" style="width: 320px;">
                <div class=" text-center">
                    <img class="logo-invitation" src="assets/images/icon_down.png" alt="Logo">
                    <div class="title">¡Hay una nueva versión de Givi disponible!</div>

                    <div>
                        <div>
                            <div class="subtitle">¡Instálala ahora!</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group text-center m-t-20">
                <a href="https://holagivi.com/apps/" target="_blank" rel="noopener" class="btn btn-dark btn-wmd">
                    Actualizar
                </a>
            </div>
        </div>
    </ng-template>

    <ng-container *ngIf="showLandingPage">
        <app-landing></app-landing>
    </ng-container>

    <ng-container *ngIf="!showLandingPage">

        <!-- Solo se muestra el Givi Scan -->
        <ng-container *ngIf="showOnlyScan">
            <!-- ============================================================== -->
            <!-- Page wrapper  -->
            <!-- ============================================================== -->
            <div class="page-wrapper" [ngClass]="{'p-0': isApp}" style="margin: 0">
                <app-breadcrumb></app-breadcrumb>
                <!-- ============================================================== -->
                <!-- Container fluid  -->
                <!-- ============================================================== -->
                <div class="container-fluid" [ngClass]="{'h-100': isApp}">
                    <!-- ============================================================== -->
                    <!-- Start Page Content -->
                    <!-- ============================================================== -->
                    <router-outlet></router-outlet>
                    <!-- ============================================================== -->
                    <!-- End Start Page Content -->
                    <!-- ============================================================== -->
                </div>
                <!-- ============================================================== -->
                <!-- End Container fluid  -->
                <!-- ============================================================== -->
            </div>
            <!-- ============================================================== -->
            <!-- End Page wrapper  -->
            <!-- ============================================================== -->
        </ng-container>

        <ng-container *ngIf="!showOnlyScan">
            <app-navigation [isDesktop]="isDesktop" [isApp]="isApp"></app-navigation>

            <!-- <div class="custom-control custom-checkbox">
                <input class="custom-control-input" id="customCheck144" type="checkbox"
                    (click)="onToggleTheme()">
                <label class="custom-control-label" for="customCheck144">Dark Theme</label>
            </div> -->
            <!-- ============================================================== -->
            <!-- Left Sidebar - style you can find in sidebar.scss  -->
            <!-- ============================================================== -->
            <!-- <aside *ngIf="!isApp" class="left-sidebar hide-print"> -->
            <!-- Sidebar scroll-->
            <!-- <div class="scroll-sidebar" [perfectScrollbar]="config" [ngStyle]="{'width': (isDesktop ? 'fit-content;': 'auto')}">
                        <app-sidebar></app-sidebar>
                </div> -->
            <!-- End Sidebar scroll-->
            <!-- </aside> -->
            <!-- ============================================================== -->
            <!-- End Left Sidebar - style you can find in sidebar.scss  -->
            <!-- ============================================================== -->
            <!-- ============================================================== -->
            <!-- Page wrapper  -->
            <!-- ============================================================== -->
            <div class="page-wrapper" [ngClass]="{'p-0': isApp}">
                <app-breadcrumb></app-breadcrumb>
                <!-- ============================================================== -->
                <!-- Container fluid  -->
                <!-- ============================================================== -->
                <div class="container-fluid" [ngClass]="{'h-100': isApp}">
                    <!-- ============================================================== -->
                    <!-- Start Page Content -->
                    <!-- ============================================================== -->
                    <router-outlet></router-outlet>
                    <!-- ============================================================== -->
                    <!-- End Start Page Content -->
                    <!-- ============================================================== -->
                </div>
                <!-- ============================================================== -->
                <!-- End Container fluid  -->
                <!-- ============================================================== -->
            </div>
            <!-- ============================================================== -->
            <!-- End Page wrapper  -->
            <!-- ============================================================== -->
            <!-- <app-footer [isDesktop]="isDesktop"></app-footer> -->
        </ng-container>
    </ng-container>
</div>